import React from 'react';
import { Card } from 'react-bootstrap';

const Body = (props) => {
    return (
        <Card.Body className="border-0">
            {props.children}
        </Card.Body>
    )
}

export default Body;